<template>
  <div>
    <v-card
      v-if="$store.state.map.movingMode"
      style="right: 0rem; top: 0rem; width: 290px"
      data-cy="moveDeviceCard"
      :coords="JSON.stringify(currentCoords)"
    >
      <v-card-title class="move-title">{{ $t('map.moveDevice.title') }}</v-card-title>
      <div class="move-content">{{ $t('map.moveDevice.content') }}</div>
      <v-card-actions class="move-actions pa-0">
        <v-btn
          @click="cancelActivation"
          color="black"
          variant="flat"
          class="btn-left"
          data-cy="cancelMoveButton"
          >{{ $t('buttons.cancel') }}</v-btn
        >
        <v-btn
          @click="completeActivation"
          variant="flat"
          class="btn-right"
          color="primary"
          data-cy="moveDoneButton"
          >{{ $t('buttons.done') }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { NAMESPACES } from '@/store/types'
import { MAP_ACTIONS } from '@/store/map'
import { DEVICE_ACTIONS, DEVICE_GETTERS } from '@/store/devices'
import type { UpdateDeviceRequest } from '@/types/devices'

export default defineComponent({
  name: 'MoveDevice',
  computed: {
    pinId(): string | undefined {
      return this.$store.state.map.deviceToMove?.deviceId
    },
    currentCoords(): { longitude: number; latitude: number } | null {
      const coords = this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_COORDS_BY_DEVICE_ID}`
      ](this.pinId)
      if (!coords) return null
      const { lng, lat } = coords
      return {
        longitude: parseFloat(lng),
        latitude: parseFloat(lat)
      }
    }
  },
  methods: {
    async completeActivation(): Promise<void> {
      if (this.currentCoords) {
        try {
          const request: UpdateDeviceRequest = { cloud_state_data: this.currentCoords }
          await this.$api.patchUpdateDevice(request, this.pinId)
        } catch (e) {
          // TODO: catch http error
          this.$store.dispatch(`${NAMESPACES.MAP}/${MAP_ACTIONS.STOP_MOVING}`)
        } finally {
          this.$store.dispatch(`${NAMESPACES.MAP}/${MAP_ACTIONS.STOP_MOVING}`)
        }
      }
    },
    cancelActivation(): void {
      const device = this.$store.state.map.deviceToMove
      this.$store.dispatch(`${NAMESPACES.DEVICES}/${DEVICE_ACTIONS.UPDATE_DEVICE_COORDS}`, device)
      this.$store.dispatch(`${NAMESPACES.MAP}/${MAP_ACTIONS.CANCEL_MOVE}`)
    }
  }
})
</script>

<style lang="scss" scoped>
.isSticky {
  position: sticky;
  background: #ffffff;
  bottom: 0;
}

.padding-16 {
  padding: 16px;
}
.form-section-header {
  opacity: 0.56;
}
.hint-text {
  font-size: 12px;
  opacity: 0.76;
}
.hint-text-button {
  margin-left: 16px;
}
.hint-text.red-font {
  color: red;
}
.v-dialog {
  .v-card {
    padding: 16px;
  }
  .v-card-title {
    font-weight: 300;
  }
  .v-card-subtitle {
    padding: 16px 24px;
  }
  .secondary-indicator {
    display: flex;
    .device-type-indicator {
      align-self: center;
      margin: 0 0 0 16px;
      img {
        height: 36px;
      }
    }
  }
  .v-btn {
    min-width: 120px !important;

    @media (min-width: 496px) {
      min-width: 160px !important;
    }
    .trailing-icon-text {
      width: 100%;
      text-indent: 30px;
    }

    &.disabled {
      border-color: grey;
      background-color: #a2a2a2 !important;
      cursor: not-allowed;
    }
  }
}

.rtl {
  direction: rtl;
}

.dialog {
  margin: 0px !important;
}

.errorMessage {
  font-size: 12px;
  color: red;
  text-align: left;
  padding-left: 16px;
}

.move-title {
  font-size: 18px;
  padding: 0.8rem;
  padding-bottom: 0.2rem;
  font-weight: 400;
}
.move-content {
  padding: 0 0.8rem 1.2rem 0.8rem;
  opacity: 0.7;
}
.move-actions {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding: 0;
  gap: 0;

  .v-btn {
    margin: 0 !important;
    padding: 0;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    height: 3.2rem;
    font-size: 1rem;

    &.btn-left {
      border-bottom-right-radius: 0;
    }

    &.btn-right {
      border-bottom-left-radius: 0;
    }
  }
}
</style>
